const labelOverrides = {
  awaiting_payment: "Awaiting payment",
  awaiting_eft: "Awaiting EFT",
  pending_review: "Pending review",
  paid_confirmed: "Paid confirmed",
  payment_under_review: "Payment under review",
  paid_awaiting_approval: "Paid awaiting approval",
  view_application_detail: "View application detail",
  view_applications: "View applications",
  confirm_payment: "Confirm payment",
  approve_application: "Approve application",
  approve_module_payments: "Approve module payments",
  resend_applicant_email: "Resend applicant email",
  manage_admins: "Manage admins",
  delete_application: "Delete application",
  full_access: "Full access",
  application_archived: "Application archived",
  application_restored: "Application restored",
  application_rejected: "Application rejected",
  application_approved: "Application approved",
  application_returned_to_review: "Application returned to review",
  application_hard_deleted: "Application hard deleted",
  admin_hard_deleted: "Admin hard deleted",
  admin_permissions_changed: "Admin permissions changed",
  admin_disabled: "Admin disabled",
  admin_enabled: "Admin enabled",
  admin_onboarding_email_sent: "Admin onboarding email sent",
  admin_onboarding_completed: "Admin onboarding completed",
  admin_login_success: "Admin login success",
  admin_login_failed: "Admin login failed",
  admin_password_changed: "Admin password changed",
  student_number_sent: "Student number sent",
  student_number_resent: "Student number resent",
  setup_link_resent: "Setup link resent",
  approval_email_sent: "Approval email sent",
  approval_email_resent: "Approval email resent",
  rejection_email_sent: "Rejection email sent",
  rejection_email_resent: "Rejection email resent",
  password_reset_requested: "Password reset requested",
  payment_confirmed: "Payment confirmed",
  payment_returned_to_review: "Payment returned to review",
  eft: "EFT",
  manual_eft: "Manual EFT",
  manual: "Manual",
  yoco: "Yoco",
  application_fee: "Application fee",
  module_payment: "Module payment",
  review_needed: "Review needed",
  not_started: "Not started",
  manual_review: "Manual review",
  manually_confirmed: "Manually confirmed",
  locked: "Locked",
  purchase_ready: "Purchase ready",
  access_granted: "Access granted",
  access_under_review: "Access under review",
  access_revoked: "Access removed",
  module_access_granted: "Module access granted",
  module_access_marked_under_review: "Module access marked under review",
  module_access_note_added: "Module access note added",
  module_access_granted_email_sent: "Module access granted email sent",
  module_access_granted_email_failed: "Module access granted email failed",
  module_access_revoked: "Module access revoked",
  module_access_revoked_email_sent: "Module access revoked email sent",
  module_access_revoked_email_failed: "Module access revoked email failed",
  sensitive_identity_revealed: "Identity revealed",
  sensitive_phone_revealed: "Phone revealed",
  sensitive_address_revealed: "Address revealed",
  not_configured: "Not configured",
};

const valueOverrides = {
  true: "Yes",
  false: "No",
  null: "—",
  undefined: "—",
};

export const formatAdminLabel = (value) => {
  if (value == null || value === "") return "—";
  const stringValue = String(value);
  if (labelOverrides[stringValue]) return labelOverrides[stringValue];
  return stringValue
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatAdminValue = (value) => {
  if (value === null) return valueOverrides.null;
  if (value === undefined) return valueOverrides.undefined;
  if (typeof value === "boolean") return valueOverrides[String(value)];
  if (typeof value === "string") {
    if (valueOverrides[value]) return valueOverrides[value];
    return formatAdminLabel(value);
  }
  return String(value);
};

export const isIsoDateValue = (value) => typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);

export const formatDisplayValue = (value) => {
  if (Array.isArray(value)) return value.map((item) => formatAdminValue(item)).join(", ");
  if (isIsoDateValue(value)) return new Date(value).toLocaleString();
  return formatAdminValue(value);
};
